import { Box, Text } from '@chakra-ui/react';
import { IconName } from '@shinetools/sunshine-icons';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import { ProofOfFundsDocumentType } from '../../machine/model';
import { locales } from './locales';

interface ProofOfFundsIntroProps {
  onSelectedOption: (option: ProofOfFundsDocumentType) => void;
}
interface ProofOfFundsOption {
  description?: string;
  iconName: IconName;
  title: string;
  id: ProofOfFundsDocumentType;
}

const PROOF_OF_FUNDS_OPTIONS: ProofOfFundsOption[] = [
  {
    description: locales.recommended,
    iconName: 'receipt',
    id: ProofOfFundsDocumentType.bankStatement,
    title: locales.types.bankStatement,
  },
  {
    iconName: 'building',
    id: ProofOfFundsDocumentType.loanCertificate,
    title: locales.types.loanCertificate,
  },
  {
    iconName: 'invoice',
    id: ProofOfFundsDocumentType.paySlip,
    title: locales.types.paySlip,
  },
];

const ProofOfFundsHub = asBentoPage<ProofOfFundsIntroProps>(
  ({ Layout, onPrev, onSelectedOption }) => {
    return (
      <Layout
        data-testid="company-papers-hub"
        nav={<OBNavigation onPrev={onPrev} />}
      >
        <Box>
          <>
            <Heading size="lg">{locales.title}</Heading>
            <Text marginTop="space-16">{locales.aboutDocument}</Text>

            <SunshineCard.Group isBoxed={false} marginTop="space-32">
              {PROOF_OF_FUNDS_OPTIONS.map((option: ProofOfFundsOption) => (
                <SunshineCard
                  alignItems="center"
                  key={option.id}
                  onClick={() => {
                    onSelectedOption(option.id);
                  }}
                  title={option.title}
                >
                  <SunshineCard.Slot name="aside">
                    <SquircleIcon colorScheme="grey" name={option.iconName} />
                  </SunshineCard.Slot>

                  <SunshineCard.Content direction="row">
                    <Text flexGrow={1} size="sm">
                      {option.description}
                    </Text>
                  </SunshineCard.Content>

                  <SunshineCard.Slot name="action">
                    <SunshineCard.SunshineIcon name="chevron-right" />
                  </SunshineCard.Slot>
                </SunshineCard>
              ))}
            </SunshineCard.Group>
          </>
        </Box>
      </Layout>
    );
  },
);

export default ProofOfFundsHub;
